module.exports = "- Use a dark Overlay with a first-run experience.\n- Use a white Overlay for dialogs and panels.\n"